// import ListPokemons from "./components/ListPokemons";
import Home from "./components/template/home";
import ListPokemons from "./components/ListPokemons";
import Footer from "./components/template/footer";

import './App.css'

function App() {
  return (
    <>
      <Home />
      
     
      <ListPokemons />  

      <Footer />
    </>
  );
}

export default App;